export function generateTempRowId() {
  return `temp_new_${Math.floor(Math.random() * 100000)}`;
}
